import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { apiUrl } from '../utils/apiBase';
import { setAuthToken } from '../utils/auth-fetch';
import { useAuth } from './auth-context';

export const LoginPage: React.FC = () => {
  const navigate = useNavigate();
  const { refresh } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    setSubmitting(true);
    setError(null);
    try {
      const res = await fetch(apiUrl('/api/auth/login'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, password }),
      });

      if (!res.ok) {
        setError('Nieprawidłowy email lub hasło.');
        setSubmitting(false);

        return;
      }

      const data = (await res.json()) as { token: string };
      setAuthToken(data.token);
      await refresh();
      navigate('/me');
    } catch {
      setError('Błąd sieci.');
      setSubmitting(false);
    }
  }

  return (
    <div className="auth-page">
      <div className="auth-card" role="region" aria-label="Logowanie">
        <span className="auth-card__score" aria-hidden="true">15 — 14</span>

        <header className="auth-card__head">
          <span className="auth-card__brand">
            <span className="auth-card__mark" aria-hidden="true">▾▴</span>
            Badminton<span className="auth-card__brand-accent">Arbiter</span>
          </span>
          <p className="auth-card__eyebrow">Wejście dla organizatorów</p>
          <h1 className="auth-card__title">Zaloguj się</h1>
        </header>

        <form onSubmit={handleSubmit} className="auth-form">
          <div className="auth-field">
            <label htmlFor="login-email" className="auth-field__label">
              <span className="auth-field__index">01</span> Email
            </label>
            <input
              id="login-email"
              type="email"
              autoComplete="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="ty@klub.pl"
              required
            />
          </div>

          <div className="auth-field">
            <label htmlFor="login-password" className="auth-field__label">
              <span className="auth-field__index">02</span> Hasło
            </label>
            <input
              id="login-password"
              type="password"
              autoComplete="current-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="••••••••"
              required
            />
          </div>

          {error && (
            <p className="auth-error" role="alert" aria-live="assertive">
              {error}
            </p>
          )}

          <button type="submit" className="auth-submit" disabled={submitting}>
            {submitting ? 'Logowanie…' : 'Zaloguj'}
          </button>
        </form>

        <p className="auth-card__alt">
          Nie masz konta? <Link to="/signup">Zarejestruj się</Link>
        </p>
      </div>
    </div>
  );
};
